export default "__VITE_ASSET__DKyRA3pi__"